import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

const analyticsService = {
  getDashboard: async () => {
    const response = await axios.get(`${API_URL}/analytics/dashboard`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response. data;
  },

  getRealtimeData: async () => {
    const response = await axios.get(`${API_URL}/analytics/realtime`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },

  getOverview: async (startDate?:  string, endDate?: string) => {
    const response = await axios.get(`${API_URL}/analytics/overview`, {
      params: { startDate, endDate },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response. data;
  },

  getTopPages: async (limit = 10) => {
    const response = await axios.get(`${API_URL}/analytics/pages`, {
      params: { limit },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },

  getDailyStats: async () => {
    const response = await axios.get(`${API_URL}/analytics/daily`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },
};

export default analyticsService;